import OlMap from '@m1/ol-map';
import classNames from 'classnames/bind';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FunctionButton } from '@/components/ui/kit/Button';
import Checkbox from '@/components/ui/kit/Checkbox';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const PhotosOverlay = ({ robotId }) => {
  const dispatch = useDispatch();
  const robotOptions = useSelector((state) => state.robotOptions[robotId]);

  const toggleVisible = (key) => {
    dispatch(actions.robotOptions.toggleVisible(robotId, key));
  };

  const changeOverlayType = (e) => {
    dispatch(actions.robotOptions.changePhotoType(robotId, e.target.value));
  };

  const resetOverlay = () => {
    OlMap.photo.remove(robotId);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('title')}>Photos Overlay</div>
      <div className={cx('box')}>
        <FieldRow label="Show Overlay" height={24}>
          <Checkbox checked={robotOptions.photo.visible} onClick={() => toggleVisible('photo')} />
        </FieldRow>
        <FieldRow label="Overlay Type">
          <Select
            value={robotOptions.photo.type}
            onChange={changeOverlayType}
            disabled={!robotOptions.photo.visible}
            className={cx('select')}>
            <option value="marker">Marker</option>
            <option value="footprint" disabled>
              Footprint
            </option>
          </Select>
        </FieldRow>
        <FieldRow label="Reset Overlay">
          <FunctionButton text="Reset" type="small" className={cx('button')} onClick={resetOverlay} />
        </FieldRow>
      </div>
    </div>
  );
};

export default PhotosOverlay;
